/**
 * StateManager — centralized widget state store
 */

const INITIAL_STATE = {
  status: 'idle', // 'idle' | 'loading' | 'results' | 'empty' | 'error'
  query: '',
  products: [],
  facets: {},
  totalCount: 0,
  currency: 'RUB',
  filters: {
    gender_ids: [],
    colors: [],
    sizes: [],
    price_min: null,
    price_max: null,
  },
  suggestions: [],
  panelOpen: false,
  cropMode: false,
  cropImageUrl: null,
};

export default class StateManager {
  constructor() {
    this._state = { ...INITIAL_STATE, filters: { ...INITIAL_STATE.filters } };
    this._subscribers = [];
  }

  /**
   * Get current state (shallow copy)
   * @returns {Object}
   */
  getState() {
    return { ...this._state };
  }

  /**
   * Update state with a partial object (shallow merge)
   * @param {Object} partial - Fields to update
   */
  setState(partial) {
    const prev = this._state;
    this._state = { ...prev, ...partial };

    // Deep-merge filters if provided
    if (partial.filters) {
      this._state.filters = { ...prev.filters, ...partial.filters };
    }

    this._notify(this._state, prev);
  }

  /**
   * Subscribe to state changes
   * @param {Function} listener - Called with (newState, prevState)
   * @returns {Function} Unsubscribe function
   */
  subscribe(listener) {
    this._subscribers.push(listener);
    return () => {
      this._subscribers = this._subscribers.filter((l) => l !== listener);
    };
  }

  /**
   * Reset state to initial values
   */
  reset() {
    const prev = this._state;
    this._state = { ...INITIAL_STATE, filters: { ...INITIAL_STATE.filters } };
    this._notify(this._state, prev);
  }

  /** @private */
  _notify(newState, prevState) {
    for (const listener of this._subscribers) {
      try {
        listener(newState, prevState);
      } catch (err) {
        console.error('[GarderoboSearch] Error in state subscriber:', err);
      }
    }
  }
}
